export default {
  name: "NotFoundView",
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  }
};